import React from 'react';
import { BaseTypography } from '../../BaseTypography/BaseTypography';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
  },
}));

export const LinearTab: React.FC<any> = React.forwardRef((props, ref) => {
  const { children, className, ...otherProps } = props;
  const classes = useStyles();
  return (
    <BaseTypography
      className={clsx(classes.root, className)}
      variant="tag"
      ref={ref}
      {...otherProps}
    >
      {children}
    </BaseTypography>
  );
});
